// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TradeSetups_container__tLsgX {
  display: grid;
  grid-template-columns: 260px 1fr 320px;
  gap: 16px;
  padding: 16px;
  color: var(--color-text);
}

.TradeSetups_banner__C0PhP {
  grid-column: 1 / -1;
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 10px 14px;
  font-size: var(--font-size-body);
  color: var(--color-text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.TradeSetups_bannerText__Kc6NU {
  text-align: center;
}

.TradeSetups_bannerMenu__W5Pfd {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
}

.TradeSetups_panel__tvvyR {
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  padding: 12px;
}

.TradeSetups_controls__4Lyzq {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.TradeSetups_controlsHeader__5WvVx {
  display: none;
}

.TradeSetups_macroBadge__89N\\+6 {
  border: 1px solid var(--color-border);
  background: var(--color-bg-alt);
  border-radius: 8px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
}

.TradeSetups_macroBadgeLabel__FYIXO {
  font-size: var(--font-size-label);
  font-weight: 600;
  color: var(--color-text);
}

.TradeSetups_macroBadgeAsOf__KT2KI {
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
}

.TradeSetups_macroTooltip__yIOtB {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 15;
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 10px 12px;
  min-width: 240px;
  max-width: 280px;
  font-weight: 400;
  font-size: var(--font-size-caption);
  color: var(--color-text);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
  display: none;
}

.TradeSetups_macroTooltipTitle__JHlNX {
  display: block;
  font-weight: 600;
  margin-bottom: 6px;
}

.TradeSetups_macroTooltipBody__-9Zri {
  display: block;
  margin-bottom: 6px;
  color: var(--color-text);
}

.TradeSetups_macroTooltipMeta__EeMur {
  display: block;
  margin-top: 4px;
  color: var(--color-text-muted);
}

.TradeSetups_macroBadge__89N\\+6:hover .TradeSetups_macroTooltip__yIOtB,
.TradeSetups_macroBadge__89N\\+6:focus-within .TradeSetups_macroTooltip__yIOtB {
  display: block;
}

.TradeSetups_kebabButton__SMqYc {
  background: transparent;
  border: 1px solid var(--color-border);
  color: var(--color-text);
  border-radius: 6px;
  padding: 4px 10px;
  font-size: var(--font-size-body);
  cursor: pointer;
}

.TradeSetups_kebabMenu__\\+\\+wvx {
  position: absolute;
  top: 34px;
  right: 0;
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 10px 12px;
  min-width: 240px;
  z-index: 30;
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.45);
  opacity: 1;
  mix-blend-mode: normal;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

.TradeSetups_kebabBackdrop__I784Z {
  position: fixed;
  inset: 0;
  z-index: 20;
  background: rgba(0, 0, 0, 0.35);
}

.TradeSetups_menuOpen__OP8pU .TradeSetups_confluenceTooltip__saFSo,
.TradeSetups_menuOpen__OP8pU .TradeSetups_confidenceTooltip__rJaAf,
.TradeSetups_menuOpen__OP8pU .TradeSetups_educationTooltip__C-O-z,
.TradeSetups_menuOpen__OP8pU .TradeSetups_macroTooltip__yIOtB,
.TradeSetups_menuOpen__OP8pU .TradeSetups_liquidityTooltip__8OzqC {
  display: none !important;
}

.TradeSetups_menuOpen__OP8pU .TradeSetups_confluenceBadge__NbANj,
.TradeSetups_menuOpen__OP8pU .TradeSetups_confidenceBadge__tk0ly,
.TradeSetups_menuOpen__OP8pU .TradeSetups_educationIcon__2mR4C,
.TradeSetups_menuOpen__OP8pU .TradeSetups_macroBadge__89N\\+6,
.TradeSetups_menuOpen__OP8pU .TradeSetups_liquidityBadge__W3z\\+q {
  pointer-events: none;
}

.TradeSetups_menuDivider__iC4mu {
  height: 1px;
  background: var(--color-border);
  margin: 10px 0;
  opacity: 0.7;
}

.TradeSetups_menuSection__RIYjK {
  display: grid;
  gap: 10px;
}

.TradeSetups_menuLabelRow__itRKF {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.TradeSetups_menuInfoIcon__CBnwk {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  color: var(--color-text-muted);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-tiny);
  position: relative;
  cursor: default;
}

.TradeSetups_menuTooltip__tF3oe {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 8px 10px;
  width: 240px;
  font-size: var(--font-size-tiny);
  color: var(--color-text);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  opacity: 0;
  pointer-events: none;
  transform: translateY(-4px);
  transition: opacity 0.2s ease, transform 0.2s ease;
  z-index: 2;
}

.TradeSetups_menuInfoIcon__CBnwk:hover .TradeSetups_menuTooltip__tF3oe,
.TradeSetups_menuInfoIcon__CBnwk:focus-visible .TradeSetups_menuTooltip__tF3oe {
  opacity: 1;
  transform: translateY(0);
}

.TradeSetups_menuField__SbOCM {
  display: grid;
  gap: 6px;
}

.TradeSetups_menuToggle__jFuee {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: var(--font-size-label);
  color: var(--color-text-muted);
}

.TradeSetups_menuLabel__50oaz {
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
  margin-bottom: 6px;
}

.TradeSetups_menuValue__Rkwgo {
  margin-top: 6px;
  font-size: var(--font-size-label);
  color: var(--color-text);
}

.TradeSetups_liquiditySettingsBox__e31UF {
  border: 1px solid var(--color-border);
  border-radius: 10px;
  padding: 10px;
  margin-top: 8px;
  display: grid;
  gap: 8px;
  background: var(--color-bg-panel);
}

.TradeSetups_liquiditySettingsTitle__2MKdF {
  font-size: var(--font-size-caption);
  font-weight: 600;
  color: var(--color-text);
}

.TradeSetups_slider__LOlwC {
  width: 100%;
}

.TradeSetups_controlGroup__NFwn1 {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.TradeSetups_controlLabel__FAPPU {
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
}

.TradeSetups_select__i-tIF,
.TradeSetups_input__CsH0g {
  background: var(--color-bg-alt);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  padding: 6px 8px;
  border-radius: 6px;
  font-size: var(--font-size-body);
}

.TradeSetups_symbolAddRow__g2qfM {
  display: flex;
  gap: 6px;
  align-items: center;
}

.TradeSetups_symbolAddRow__g2qfM .TradeSetups_input__CsH0g {
  flex: 1 1;
}

.TradeSetups_addButton__ihSe2 {
  background: var(--color-accent);
  color: var(--color-text);
  border: none;
  border-radius: 6px;
  padding: 0;
  margin-left: auto;
  width: 36px;
  height: 32px;
  font-size: var(--font-size-body);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  white-space: nowrap;
}

.TradeSetups_addButton__ihSe2:hover {
  opacity: 0.9;
}

.TradeSetups_symbolError__gb0B9 {
  font-size: var(--font-size-caption);
  color: var(--color-danger);
}

.TradeSetups_symbolList__03Em0 {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.TradeSetups_symbolChip__BRPhV {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-panel);
  font-size: var(--font-size-caption);
}

.TradeSetups_symbolRemove__hOu63 {
  background: transparent;
  border: none;
  color: var(--color-text-muted);
  font-size: var(--font-size-body);
  cursor: pointer;
  line-height: 1;
}

.TradeSetups_toggleRow__x0PLM {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: var(--font-size-body);
}

.TradeSetups_filtersSection__-PRZZ {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--color-border);
  display: grid;
  gap: 10px;
}

.TradeSetups_filtersTitle__lKLcJ {
  font-size: var(--font-size-tiny);
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--color-text-muted);
}

.TradeSetups_filtersGrid__6\\+GiA {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
}

.TradeSetups_filterToggle__MNZ7A {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: var(--font-size-label);
  color: var(--color-text-muted);
}

.TradeSetups_filtersNote__C8sfB {
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
}

.TradeSetups_chartPanel__s-\\+ks {
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  padding: 10px;
}

.TradeSetups_setupsHeader__ynXBz {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.TradeSetups_setupsHeaderLeft__CwaQw {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.TradeSetups_setupsHeaderRight__RPS6f {
  display: flex;
  align-items: center;
  gap: 8px;
}

.TradeSetups_setupsHeaderTitle__g-xB\\+ {
  font-weight: 600;
}

.TradeSetups_setupsHeaderMeta__xRjW4 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.TradeSetups_setupsTabs__ukJfv {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.TradeSetups_setupsTab__T2ytl {
  border: 1px solid var(--color-border);
  border-radius: 999px;
  padding: 4px 10px;
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
  background: transparent;
  cursor: pointer;
}

.TradeSetups_setupsTabActive__pa16e {
  color: var(--color-text);
  background: var(--color-bg-panel);
}

.TradeSetups_educationIcon__2mR4C {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  color: var(--color-text-muted);
  font-size: var(--font-size-tiny);
  cursor: default;
  position: relative;
}

.TradeSetups_educationTooltip__C-O-z {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 15;
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 10px 12px;
  min-width: 240px;
  max-width: 280px;
  font-weight: 400;
  font-size: var(--font-size-caption);
  color: var(--color-text);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
  display: none;
}

.TradeSetups_educationTooltipTitle__EwGt4 {
  display: block;
  font-weight: 600;
  margin-bottom: 6px;
  color: var(--color-text);
}

.TradeSetups_educationTooltipList__ElqIv {
  margin: 0;
  padding-left: 16px;
  color: var(--color-text-muted);
}

.TradeSetups_educationIcon__2mR4C:hover .TradeSetups_educationTooltip__C-O-z,
.TradeSetups_educationIcon__2mR4C:focus-visible .TradeSetups_educationTooltip__C-O-z {
  display: block;
}

.TradeSetups_setupCard__YIAKR {
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
  background: var(--color-bg-alt);
}

.TradeSetups_setupCardExpired__n2TYh {
  opacity: 0.6;
}

.TradeSetups_setupTitleRow__b2kjv {
  font-size: var(--font-size-body);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}

.TradeSetups_setupBadgeRow__veYrH {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
}

.TradeSetups_liquidityList__a3XBU {
  display: grid;
  gap: 12px;
}

.TradeSetups_liquidityCard__bQO98 {
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  padding: 12px;
}

.TradeSetups_liquidityHeader__vH5mw {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: var(--font-size-body);
  font-weight: 600;
  color: var(--color-text-strong);
}

.TradeSetups_liquidityTitle__E-Ft5 {
  color: var(--color-text-strong);
}

.TradeSetups_liquidityRange__t2ocv {
  color: var(--color-text);
  font-weight: 600;
}

.TradeSetups_liquidityMeta__OYtSc {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 6px;
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
}

.TradeSetups_liquidityActions__eyPG8 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 6px;
}

.TradeSetups_liquidityToggle__2i9Es {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--font-size-caption);
  color: var(--color-text);
}

.TradeSetups_liquidityZoomButton__yRP4Q {
  border: 1px solid var(--color-border);
  border-radius: 999px;
  background: var(--color-bg-muted);
  color: var(--color-text);
  font-size: var(--font-size-tiny);
  padding: 3px 10px;
  cursor: pointer;
}

.TradeSetups_liquidityZoomButton__yRP4Q:hover {
  background: var(--color-bg-panel);
  border-color: var(--color-accent);
  color: var(--color-accent);
}

.TradeSetups_liquidityZoomButton__yRP4Q:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--color-accent);
}

.TradeSetups_setupActions__fayK6 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.TradeSetups_fitSetupButton__QLnjJ {
  border: 1px solid var(--color-border);
  border-radius: 999px;
  background: var(--color-bg-muted);
  color: var(--color-text);
  font-size: var(--font-size-tiny);
  padding: 3px 10px;
  cursor: pointer;
}

.TradeSetups_fitSetupButton__QLnjJ:hover {
  background: var(--color-bg-panel);
  border-color: var(--color-accent);
  color: var(--color-accent);
}

.TradeSetups_fitSetupButton__QLnjJ:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--color-accent);
}

.TradeSetups_zoomSetupButton__HmMk1 {
  border: 1px solid var(--color-border);
  border-radius: 999px;
  background: var(--color-bg-muted);
  color: var(--color-text);
  font-size: var(--font-size-tiny);
  padding: 3px 10px;
  cursor: pointer;
}

.TradeSetups_zoomSetupButton__HmMk1:hover {
  background: var(--color-bg-panel);
  border-color: var(--color-accent);
  color: var(--color-accent);
}

.TradeSetups_zoomSetupButton__HmMk1:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--color-accent);
}

.TradeSetups_liquidityEmpty__6NlMs {
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
  padding: 6px 4px;
}

.TradeSetups_badge__N3OZ6 {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 999px;
  font-size: var(--font-size-tiny);
  margin-left: 6px;
  border: 1px solid var(--color-border);
}

.TradeSetups_badgeActive__OWX2m {
  color: var(--color-success);
}

.TradeSetups_badgeTriggered__c03mS {
  color: var(--color-warning);
}

.TradeSetups_badgeExpired__uUU2O {
  color: var(--color-text-muted);
}

.TradeSetups_badgeHigh__xMfsA {
  color: var(--color-success);
}

.TradeSetups_badgeMed__pvXDQ {
  color: var(--color-warning);
}

.TradeSetups_badgeLow__km6st {
  color: var(--color-text-muted);
}

.TradeSetups_badgeFvg__49xL4 {
  background: var(--color-bg-muted);
  border: 1px solid var(--color-border);
  color: var(--color-text);
}

.TradeSetups_liquidityBadge__W3z\\+q {
  position: relative;
  background: var(--color-bg-muted);
  border: 1px solid var(--color-border);
  color: var(--color-text);
}

.TradeSetups_liquidityaligned__1OoYf {
  color: var(--color-success);
}

.TradeSetups_liquiditycounter__tbXHV {
  color: var(--color-warning);
}

.TradeSetups_liquiditynone__W6ueU {
  color: var(--color-text-muted);
}

.TradeSetups_liquidityTooltip__8OzqC {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 15;
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 8px 10px;
  min-width: 200px;
  max-width: 240px;
  font-weight: 400;
  font-size: var(--font-size-caption);
  color: var(--color-text);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
  display: none;
}

.TradeSetups_liquidityBadge__W3z\\+q:hover .TradeSetups_liquidityTooltip__8OzqC,
.TradeSetups_liquidityBadge__W3z\\+q:focus-within .TradeSetups_liquidityTooltip__8OzqC {
  display: block;
}

.TradeSetups_confidenceBadge__tk0ly {
  position: relative;
}

.TradeSetups_confidenceTooltip__rJaAf {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 15;
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 10px 12px;
  min-width: 220px;
  max-width: 260px;
  font-weight: 400;
  font-size: var(--font-size-caption);
  color: var(--color-text);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
  display: none;
}

.TradeSetups_confidenceTooltipTitle__EkYyU {
  display: block;
  font-weight: 600;
  margin-bottom: 6px;
  color: var(--color-text);
}

.TradeSetups_confidenceTooltipList__0AHy5 {
  margin: 0;
  padding-left: 16px;
  color: var(--color-text-muted);
}

.TradeSetups_confidenceBadge__tk0ly:hover .TradeSetups_confidenceTooltip__rJaAf,
.TradeSetups_confidenceBadge__tk0ly:focus-visible .TradeSetups_confidenceTooltip__rJaAf {
  display: block;
}

.TradeSetups_confluenceBadge__NbANj {
  position: relative;
  text-transform: uppercase;
  font-size: var(--font-size-tiny);
}

.TradeSetups_confluenceAligned__czMyC {
  color: var(--color-success);
}

.TradeSetups_confluenceCounter__Pt\\+Yc {
  color: var(--color-danger);
}

.TradeSetups_confluenceNeutral__xnbOG {
  color: var(--color-text-muted);
}

.TradeSetups_confluenceUnavailable__DHBZJ {
  color: var(--color-text-muted);
}

.TradeSetups_confluenceTooltip__saFSo {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 15;
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 8px 10px;
  min-width: 220px;
  max-width: 260px;
  font-weight: 400;
  font-size: var(--font-size-caption);
  color: var(--color-text);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
  display: none;
}

.TradeSetups_confluenceBadge__NbANj:hover .TradeSetups_confluenceTooltip__saFSo,
.TradeSetups_confluenceBadge__NbANj:focus-visible .TradeSetups_confluenceTooltip__saFSo {
  display: block;
}

.TradeSetups_sessionBadge__kt78y {
  margin-top: 6px;
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
}

.TradeSetups_expiredNote__fqTsN {
  margin-top: 4px;
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
}

.TradeSetups_macroFootnote__KlcpK {
  margin-top: 8px;
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
}

.TradeSetups_historySection__2BlbW {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid var(--color-border);
}

.TradeSetups_historyHeader__dA8N2 {
  font-size: var(--font-size-body);
  font-weight: 600;
  color: var(--color-text);
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  list-style: none;
}

.TradeSetups_historyHeader__dA8N2::-webkit-details-marker {
  display: none;
}

.TradeSetups_historySection__2BlbW[open] > .TradeSetups_historyHeader__dA8N2 .TradeSetups_historyChevron__DANaJ {
  transform: rotate(180deg);
}

.TradeSetups_historyList__rlYhf {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.TradeSetups_historyChevron__DANaJ {
  font-size: var(--font-size-tiny);
  color: var(--color-text-muted);
  white-space: nowrap;
}

.TradeSetups_historyCard__IB\\+29 {
  border: 1px solid var(--color-border);
  border-radius: 10px;
  padding: 16px;
  background: var(--color-bg-panel);
  transition: background 120ms ease-out;
}

.TradeSetups_historyCard__IB\\+29:hover {
  background: var(--color-bg-muted);
}

.TradeSetups_historyCardHeader__1BCAO {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.TradeSetups_historyExpandButton__6IQ3P {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-muted);
  color: var(--color-text);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-body);
  cursor: pointer;
}

.TradeSetups_historyExpandButton__6IQ3P:hover {
  border-color: var(--color-accent);
  color: var(--color-accent);
}

.TradeSetups_historyExpandButton__6IQ3P:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--color-accent);
}

.TradeSetups_historyCardTitle__w7Y85 {
  font-size: var(--font-size-body);
  font-weight: 600;
  color: var(--color-text);
}

.TradeSetups_historyStatusBadge__zGdkb {
  border-radius: 999px;
  padding: 2px 10px;
  font-size: var(--font-size-caption);
  font-weight: 500;
  border: 1px solid var(--color-border);
  text-transform: uppercase;
}

.TradeSetups_historyStatusSuccess__52E8T {
  color: var(--color-success);
}

.TradeSetups_historyStatusFailed__o4x8J {
  color: var(--color-danger);
}

.TradeSetups_historyStatusTriggered__qQgBY {
  color: var(--color-warning);
}

.TradeSetups_historyTimestamp__g50zc {
  margin-top: 4px;
  font-size: var(--font-size-tiny);
  color: var(--color-text-muted);
}

.TradeSetups_historyGrid__jWndx {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 24px;
}

.TradeSetups_historyGridItem__BZiVT {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.TradeSetups_historyGridLabel__URnhK {
  font-size: var(--font-size-tiny);
  color: var(--color-text-muted);
}

.TradeSetups_historyGridValue__s9vLj {
  font-size: var(--font-size-body);
  font-weight: 500;
  color: var(--color-text);
}

.TradeSetups_historyFooter__cuUkj {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: var(--font-size-tiny);
  color: var(--color-text-muted);
  flex-wrap: wrap;
}

.TradeSetups_historyFooterNote__Z-0n8 {
  color: var(--color-text-muted);
}

.TradeSetups_historyPagination__0r7jn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 12px;
}

.TradeSetups_historyPageButton__rN3IY {
  border: 1px solid var(--color-border);
  border-radius: 999px;
  background: var(--color-bg-muted);
  color: var(--color-text);
  font-size: var(--font-size-tiny);
  padding: 4px 12px;
  cursor: pointer;
}

.TradeSetups_historyPageButton__rN3IY:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.TradeSetups_historyPageButton__rN3IY:hover:not(:disabled) {
  background: var(--color-bg-panel);
  border-color: var(--color-accent);
  color: var(--color-accent);
}

.TradeSetups_historyPageButton__rN3IY:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--color-accent);
}

.TradeSetups_historyPageInfo__ywIeK {
  font-size: var(--font-size-tiny);
  color: var(--color-text-muted);
}

.TradeSetups_historyToggle__sRBBL {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: var(--font-size-tiny);
  color: var(--color-text-muted);
}

.TradeSetups_historyStatsButton__4dx4W {
  margin-left: auto;
  width: 34px;
  height: 34px;
  border-radius: 999px;
  border: 1px solid var(--color-accent);
  background-color: var(--color-accent);
  color: var(--color-surface);
  font-size: var(--font-size-body);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  gap: 6px;
}

.TradeSetups_historyStatsButton__4dx4W:hover {
  opacity: 0.9;
}

.TradeSetups_historyStatsTooltip__AngII {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 6px 8px;
  font-size: var(--font-size-tiny);
  color: var(--color-text);
  white-space: nowrap;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  opacity: 0;
  pointer-events: none;
  transform: translateY(-4px);
  transition: opacity 0.2s ease, transform 0.2s ease;
  z-index: 10;
}

.TradeSetups_historyStatsButton__4dx4W:hover .TradeSetups_historyStatsTooltip__AngII,
.TradeSetups_historyStatsButton__4dx4W:focus-visible .TradeSetups_historyStatsTooltip__AngII {
  opacity: 1;
  transform: translateY(0);
}

.TradeSetups_historyStatsOverlay__93DGz {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
}

.TradeSetups_historyStatsBackdrop__DQaAf {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(2px);
}

.TradeSetups_historyStatsModal__kzwJK {
  position: relative;
  z-index: 1;
  width: min(30vw, 520px);
  color: var(--color-text);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);
  font-weight: 700;
}

.TradeSetups_historyStatsCard__lq1gA {
  background-color: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 20px;
}

.TradeSetups_historyStatsHeader__kX9ou {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.TradeSetups_historyStatsTitle__6g-bB {
  font-size: var(--font-size-body);
  font-weight: 600;
  color: var(--color-text);
}

.TradeSetups_historyStatsClose__1cj0B {
  background: none;
  border: none;
  color: var(--color-text-muted);
  font-size: var(--font-size-body);
  cursor: pointer;
}

.TradeSetups_historyStatsBody__dPIBH {
  display: grid;
  gap: 8px;
  font-size: var(--font-size-body);
  color: var(--color-text-muted);
}

.TradeSetups_historyStatsViz__2Zwnv {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 6px;
}

.TradeSetups_historyStatsPieChart__\\+5cin {
  width: min(60%, 320px);
  aspect-ratio: 1 / 1;
  min-width: 140px;
  height: auto;
}

.TradeSetups_historyStatsLegend__f1FrT {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: var(--font-size-body);
  color: var(--color-text-muted);
  width: 100%;
  justify-content: center;
}


.TradeSetups_historyStatsLegendItem__oAuiH {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.TradeSetups_historyStatsLegendSwatch__c4wWd {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  display: inline-block;
}

.TradeSetups_historyStatsLegendSuccess__N0QwY {
  background-color: var(--color-success);
}

.TradeSetups_historyStatsLegendFailed__1BSQI {
  background-color: var(--color-danger);
}

.TradeSetups_historyStatsLegendOther__hyzBD {
  background-color: var(--color-warning);
}

.TradeSetups_historyStatsRow__8FzNE {
  display: flex;
  justify-content: space-between;
  font-size: var(--font-size-body);
}

.TradeSetups_historyStatsFooter__\\+bVJ9 {
  font-size: var(--font-size-body);
  color: var(--color-text-muted);
  margin-top: 6px;
}

.TradeSetups_historyStatsEmpty__rf-S1 {
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
}

.TradeSetups_historyEmpty__ylwtw {
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
}

.TradeSetups_setupInfoIcon__v9HqQ {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  color: var(--color-text-muted);
  font-size: var(--font-size-tiny);
  cursor: default;
  position: relative;
}

.TradeSetups_setupTooltip__ruM1z {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 15;
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 10px 12px;
  min-width: 240px;
  max-width: 280px;
  font-weight: 400;
  font-size: var(--font-size-caption);
  color: var(--color-text);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
  display: none;
}

.TradeSetups_setupTooltipTitle__A4jwK {
  display: block;
  font-weight: 600;
  margin-bottom: 6px;
  color: var(--color-text);
}

.TradeSetups_setupTooltipList__AB0zd {
  margin: 0;
  padding-left: 16px;
  color: var(--color-text-muted);
}

.TradeSetups_setupInfoIcon__v9HqQ:hover .TradeSetups_setupTooltip__ruM1z,
.TradeSetups_setupInfoIcon__v9HqQ:focus-visible .TradeSetups_setupTooltip__ruM1z {
  display: block;
}

.TradeSetups_levels__tHIea {
  margin-top: 6px;
  font-size: var(--font-size-label);
  color: var(--color-text-muted);
}

.TradeSetups_zoneToggle__bPuRX {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  font-size: var(--font-size-caption);
  color: var(--color-text);
}

.TradeSetups_list__WooyY {
  margin: 6px 0 0 14px;
  padding: 0;
  color: var(--color-text-muted);
  font-size: var(--font-size-caption);
}

.TradeSetups_checklist__txln\\+ {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.TradeSetups_checkItem__pAtUh {
  font-size: var(--font-size-tiny);
  border-radius: 999px;
  padding: 2px 6px;
  border: 1px solid var(--color-border);
}

.TradeSetups_checkPass__Bc9Mr {
  color: var(--color-success);
}

.TradeSetups_checkFail__jyEk3 {
  color: var(--color-danger);
}

@media (max-width: 1200px) {
  .TradeSetups_container__tLsgX {
    grid-template-columns: 1fr;
  }
}

.TradeSetups_countdown__5MjB6 {
  font-size: var(--font-size-body);
  font-weight: 600;
  color: var(--color-text-strong);
}
`, "",{"version":3,"sources":["webpack://./src/components/TradeSetups/TradeSetups.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,wBAAwB;EACxB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,8BAA8B;AAChC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,2CAA2C;EAC3C,UAAU;EACV,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,+BAA+B;AACjC;;AAEA;;;;;EAKE,wBAAwB;AAC1B;;AAEA;;;;;EAKE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,gCAAgC;EAChC,wBAAwB;EACxB,0CAA0C;EAC1C,UAAU;EACV,oBAAoB;EACpB,2BAA2B;EAC3B,kDAAkD;EAClD,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,aAAa;EACb,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;EAC/B,qCAAqC;EACrC,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,mCAAmC;EACnC,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,wBAAwB;EACxB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gCAAgC;EAChC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,iCAAiC;EACjC,wBAAwB;EACxB,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,iCAAiC;EACjC,wBAAwB;EACxB,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,iCAAiC;EACjC,wBAAwB;EACxB,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,wBAAwB;EACxB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,wBAAwB;EACxB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,wBAAwB;EACxB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mCAAmC;EACnC,gBAAgB;EAChB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,iCAAiC;EACjC,wBAAwB;EACxB,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,qCAAqC;EACrC,2BAA2B;EAC3B,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,wBAAwB;EACxB,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,oBAAoB;EACpB,2BAA2B;EAC3B,kDAAkD;EAClD,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,wBAAwB;EACxB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,WAAW;EACX,uBAAuB;AACzB;;;AAGA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,wBAAwB;EACxB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,+BAA+B;AACjC","sourcesContent":[".container {\n  display: grid;\n  grid-template-columns: 260px 1fr 320px;\n  gap: 16px;\n  padding: 16px;\n  color: var(--color-text);\n}\n\n.banner {\n  grid-column: 1 / -1;\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: var(--font-size-body);\n  color: var(--color-text-muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.bannerText {\n  text-align: center;\n}\n\n.bannerMenu {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.panel {\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 10px;\n  padding: 12px;\n}\n\n.controls {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.controlsHeader {\n  display: none;\n}\n\n.macroBadge {\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-alt);\n  border-radius: 8px;\n  padding: 8px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  position: relative;\n}\n\n.macroBadgeLabel {\n  font-size: var(--font-size-label);\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.macroBadgeAsOf {\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n}\n\n.macroTooltip {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  z-index: 15;\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 10px 12px;\n  min-width: 240px;\n  max-width: 280px;\n  font-weight: 400;\n  font-size: var(--font-size-caption);\n  color: var(--color-text);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);\n  display: none;\n}\n\n.macroTooltipTitle {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 6px;\n}\n\n.macroTooltipBody {\n  display: block;\n  margin-bottom: 6px;\n  color: var(--color-text);\n}\n\n.macroTooltipMeta {\n  display: block;\n  margin-top: 4px;\n  color: var(--color-text-muted);\n}\n\n.macroBadge:hover .macroTooltip,\n.macroBadge:focus-within .macroTooltip {\n  display: block;\n}\n\n.kebabButton {\n  background: transparent;\n  border: 1px solid var(--color-border);\n  color: var(--color-text);\n  border-radius: 6px;\n  padding: 4px 10px;\n  font-size: var(--font-size-body);\n  cursor: pointer;\n}\n\n.kebabMenu {\n  position: absolute;\n  top: 34px;\n  right: 0;\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 10px 12px;\n  min-width: 240px;\n  z-index: 30;\n  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.45);\n  opacity: 1;\n  mix-blend-mode: normal;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n}\n\n.kebabBackdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 20;\n  background: rgba(0, 0, 0, 0.35);\n}\n\n.menuOpen .confluenceTooltip,\n.menuOpen .confidenceTooltip,\n.menuOpen .educationTooltip,\n.menuOpen .macroTooltip,\n.menuOpen .liquidityTooltip {\n  display: none !important;\n}\n\n.menuOpen .confluenceBadge,\n.menuOpen .confidenceBadge,\n.menuOpen .educationIcon,\n.menuOpen .macroBadge,\n.menuOpen .liquidityBadge {\n  pointer-events: none;\n}\n\n.menuDivider {\n  height: 1px;\n  background: var(--color-border);\n  margin: 10px 0;\n  opacity: 0.7;\n}\n\n.menuSection {\n  display: grid;\n  gap: 10px;\n}\n\n.menuLabelRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.menuInfoIcon {\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n  color: var(--color-text-muted);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-size-tiny);\n  position: relative;\n  cursor: default;\n}\n\n.menuTooltip {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 8px 10px;\n  width: 240px;\n  font-size: var(--font-size-tiny);\n  color: var(--color-text);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(-4px);\n  transition: opacity 0.2s ease, transform 0.2s ease;\n  z-index: 2;\n}\n\n.menuInfoIcon:hover .menuTooltip,\n.menuInfoIcon:focus-visible .menuTooltip {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.menuField {\n  display: grid;\n  gap: 6px;\n}\n\n.menuToggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: var(--font-size-label);\n  color: var(--color-text-muted);\n}\n\n.menuLabel {\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n  margin-bottom: 6px;\n}\n\n.menuValue {\n  margin-top: 6px;\n  font-size: var(--font-size-label);\n  color: var(--color-text);\n}\n\n.liquiditySettingsBox {\n  border: 1px solid var(--color-border);\n  border-radius: 10px;\n  padding: 10px;\n  margin-top: 8px;\n  display: grid;\n  gap: 8px;\n  background: var(--color-bg-panel);\n}\n\n.liquiditySettingsTitle {\n  font-size: var(--font-size-caption);\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.slider {\n  width: 100%;\n}\n\n.controlGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.controlLabel {\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n}\n\n.select,\n.input {\n  background: var(--color-bg-alt);\n  border: 1px solid var(--color-border);\n  color: var(--color-text);\n  padding: 6px 8px;\n  border-radius: 6px;\n  font-size: var(--font-size-body);\n}\n\n.symbolAddRow {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.symbolAddRow .input {\n  flex: 1;\n}\n\n.addButton {\n  background: var(--color-accent);\n  color: var(--color-text);\n  border: none;\n  border-radius: 6px;\n  padding: 0;\n  margin-left: auto;\n  width: 36px;\n  height: 32px;\n  font-size: var(--font-size-body);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.addButton:hover {\n  opacity: 0.9;\n}\n\n.symbolError {\n  font-size: var(--font-size-caption);\n  color: var(--color-danger);\n}\n\n.symbolList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.symbolChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-panel);\n  font-size: var(--font-size-caption);\n}\n\n.symbolRemove {\n  background: transparent;\n  border: none;\n  color: var(--color-text-muted);\n  font-size: var(--font-size-body);\n  cursor: pointer;\n  line-height: 1;\n}\n\n.toggleRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: var(--font-size-body);\n}\n\n.filtersSection {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--color-border);\n  display: grid;\n  gap: 10px;\n}\n\n.filtersTitle {\n  font-size: var(--font-size-tiny);\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: var(--color-text-muted);\n}\n\n.filtersGrid {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n}\n\n.filterToggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: var(--font-size-label);\n  color: var(--color-text-muted);\n}\n\n.filtersNote {\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n}\n\n.chartPanel {\n  background: var(--color-bg);\n  border: 1px solid var(--color-border);\n  border-radius: 10px;\n  padding: 10px;\n}\n\n.setupsHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.setupsHeaderLeft {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.setupsHeaderRight {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.setupsHeaderTitle {\n  font-weight: 600;\n}\n\n.setupsHeaderMeta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.setupsTabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.setupsTab {\n  border: 1px solid var(--color-border);\n  border-radius: 999px;\n  padding: 4px 10px;\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n  background: transparent;\n  cursor: pointer;\n}\n\n.setupsTabActive {\n  color: var(--color-text);\n  background: var(--color-bg-panel);\n}\n\n.educationIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n  color: var(--color-text-muted);\n  font-size: var(--font-size-tiny);\n  cursor: default;\n  position: relative;\n}\n\n.educationTooltip {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 15;\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 10px 12px;\n  min-width: 240px;\n  max-width: 280px;\n  font-weight: 400;\n  font-size: var(--font-size-caption);\n  color: var(--color-text);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);\n  display: none;\n}\n\n.educationTooltipTitle {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 6px;\n  color: var(--color-text);\n}\n\n.educationTooltipList {\n  margin: 0;\n  padding-left: 16px;\n  color: var(--color-text-muted);\n}\n\n.educationIcon:hover .educationTooltip,\n.educationIcon:focus-visible .educationTooltip {\n  display: block;\n}\n\n.setupCard {\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 10px;\n  margin-bottom: 10px;\n  background: var(--color-bg-alt);\n}\n\n.setupCardExpired {\n  opacity: 0.6;\n}\n\n.setupTitleRow {\n  font-size: var(--font-size-body);\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.setupBadgeRow {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.liquidityList {\n  display: grid;\n  gap: 12px;\n}\n\n.liquidityCard {\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 10px;\n  padding: 12px;\n}\n\n.liquidityHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: var(--font-size-body);\n  font-weight: 600;\n  color: var(--color-text-strong);\n}\n\n.liquidityTitle {\n  color: var(--color-text-strong);\n}\n\n.liquidityRange {\n  color: var(--color-text);\n  font-weight: 600;\n}\n\n.liquidityMeta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 6px;\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n}\n\n.liquidityActions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: 6px;\n}\n\n.liquidityToggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: var(--font-size-caption);\n  color: var(--color-text);\n}\n\n.liquidityZoomButton {\n  border: 1px solid var(--color-border);\n  border-radius: 999px;\n  background: var(--color-bg-muted);\n  color: var(--color-text);\n  font-size: var(--font-size-tiny);\n  padding: 3px 10px;\n  cursor: pointer;\n}\n\n.liquidityZoomButton:hover {\n  background: var(--color-bg-panel);\n  border-color: var(--color-accent);\n  color: var(--color-accent);\n}\n\n.liquidityZoomButton:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--color-accent);\n}\n\n.setupActions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 8px;\n  flex-wrap: wrap;\n}\n\n.fitSetupButton {\n  border: 1px solid var(--color-border);\n  border-radius: 999px;\n  background: var(--color-bg-muted);\n  color: var(--color-text);\n  font-size: var(--font-size-tiny);\n  padding: 3px 10px;\n  cursor: pointer;\n}\n\n.fitSetupButton:hover {\n  background: var(--color-bg-panel);\n  border-color: var(--color-accent);\n  color: var(--color-accent);\n}\n\n.fitSetupButton:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--color-accent);\n}\n\n.zoomSetupButton {\n  border: 1px solid var(--color-border);\n  border-radius: 999px;\n  background: var(--color-bg-muted);\n  color: var(--color-text);\n  font-size: var(--font-size-tiny);\n  padding: 3px 10px;\n  cursor: pointer;\n}\n\n.zoomSetupButton:hover {\n  background: var(--color-bg-panel);\n  border-color: var(--color-accent);\n  color: var(--color-accent);\n}\n\n.zoomSetupButton:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--color-accent);\n}\n\n.liquidityEmpty {\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n  padding: 6px 4px;\n}\n\n.badge {\n  display: inline-block;\n  padding: 2px 6px;\n  border-radius: 999px;\n  font-size: var(--font-size-tiny);\n  margin-left: 6px;\n  border: 1px solid var(--color-border);\n}\n\n.badgeActive {\n  color: var(--color-success);\n}\n\n.badgeTriggered {\n  color: var(--color-warning);\n}\n\n.badgeExpired {\n  color: var(--color-text-muted);\n}\n\n.badgeHigh {\n  color: var(--color-success);\n}\n\n.badgeMed {\n  color: var(--color-warning);\n}\n\n.badgeLow {\n  color: var(--color-text-muted);\n}\n\n.badgeFvg {\n  background: var(--color-bg-muted);\n  border: 1px solid var(--color-border);\n  color: var(--color-text);\n}\n\n.liquidityBadge {\n  position: relative;\n  background: var(--color-bg-muted);\n  border: 1px solid var(--color-border);\n  color: var(--color-text);\n}\n\n.liquidityaligned {\n  color: var(--color-success);\n}\n\n.liquiditycounter {\n  color: var(--color-warning);\n}\n\n.liquiditynone {\n  color: var(--color-text-muted);\n}\n\n.liquidityTooltip {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 15;\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 8px 10px;\n  min-width: 200px;\n  max-width: 240px;\n  font-weight: 400;\n  font-size: var(--font-size-caption);\n  color: var(--color-text);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);\n  display: none;\n}\n\n.liquidityBadge:hover .liquidityTooltip,\n.liquidityBadge:focus-within .liquidityTooltip {\n  display: block;\n}\n\n.confidenceBadge {\n  position: relative;\n}\n\n.confidenceTooltip {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 15;\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 10px 12px;\n  min-width: 220px;\n  max-width: 260px;\n  font-weight: 400;\n  font-size: var(--font-size-caption);\n  color: var(--color-text);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);\n  display: none;\n}\n\n.confidenceTooltipTitle {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 6px;\n  color: var(--color-text);\n}\n\n.confidenceTooltipList {\n  margin: 0;\n  padding-left: 16px;\n  color: var(--color-text-muted);\n}\n\n.confidenceBadge:hover .confidenceTooltip,\n.confidenceBadge:focus-visible .confidenceTooltip {\n  display: block;\n}\n\n.confluenceBadge {\n  position: relative;\n  text-transform: uppercase;\n  font-size: var(--font-size-tiny);\n}\n\n.confluenceAligned {\n  color: var(--color-success);\n}\n\n.confluenceCounter {\n  color: var(--color-danger);\n}\n\n.confluenceNeutral {\n  color: var(--color-text-muted);\n}\n\n.confluenceUnavailable {\n  color: var(--color-text-muted);\n}\n\n.confluenceTooltip {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 15;\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 8px 10px;\n  min-width: 220px;\n  max-width: 260px;\n  font-weight: 400;\n  font-size: var(--font-size-caption);\n  color: var(--color-text);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);\n  display: none;\n}\n\n.confluenceBadge:hover .confluenceTooltip,\n.confluenceBadge:focus-visible .confluenceTooltip {\n  display: block;\n}\n\n.sessionBadge {\n  margin-top: 6px;\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n}\n\n.expiredNote {\n  margin-top: 4px;\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n}\n\n.macroFootnote {\n  margin-top: 8px;\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n}\n\n.historySection {\n  margin-top: 12px;\n  padding-top: 10px;\n  border-top: 1px solid var(--color-border);\n}\n\n.historyHeader {\n  font-size: var(--font-size-body);\n  font-weight: 600;\n  color: var(--color-text);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  list-style: none;\n}\n\n.historyHeader::-webkit-details-marker {\n  display: none;\n}\n\n.historySection[open] > .historyHeader .historyChevron {\n  transform: rotate(180deg);\n}\n\n.historyList {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.historyChevron {\n  font-size: var(--font-size-tiny);\n  color: var(--color-text-muted);\n  white-space: nowrap;\n}\n\n.historyCard {\n  border: 1px solid var(--color-border);\n  border-radius: 10px;\n  padding: 16px;\n  background: var(--color-bg-panel);\n  transition: background 120ms ease-out;\n}\n\n.historyCard:hover {\n  background: var(--color-bg-muted);\n}\n\n.historyCardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.historyExpandButton {\n  width: 26px;\n  height: 26px;\n  border-radius: 6px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-muted);\n  color: var(--color-text);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-size-body);\n  cursor: pointer;\n}\n\n.historyExpandButton:hover {\n  border-color: var(--color-accent);\n  color: var(--color-accent);\n}\n\n.historyExpandButton:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--color-accent);\n}\n\n.historyCardTitle {\n  font-size: var(--font-size-body);\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.historyStatusBadge {\n  border-radius: 999px;\n  padding: 2px 10px;\n  font-size: var(--font-size-caption);\n  font-weight: 500;\n  border: 1px solid var(--color-border);\n  text-transform: uppercase;\n}\n\n.historyStatusSuccess {\n  color: var(--color-success);\n}\n\n.historyStatusFailed {\n  color: var(--color-danger);\n}\n\n.historyStatusTriggered {\n  color: var(--color-warning);\n}\n\n.historyTimestamp {\n  margin-top: 4px;\n  font-size: var(--font-size-tiny);\n  color: var(--color-text-muted);\n}\n\n.historyGrid {\n  margin-top: 10px;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px 24px;\n}\n\n.historyGridItem {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.historyGridLabel {\n  font-size: var(--font-size-tiny);\n  color: var(--color-text-muted);\n}\n\n.historyGridValue {\n  font-size: var(--font-size-body);\n  font-weight: 500;\n  color: var(--color-text);\n}\n\n.historyFooter {\n  margin-top: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  font-size: var(--font-size-tiny);\n  color: var(--color-text-muted);\n  flex-wrap: wrap;\n}\n\n.historyFooterNote {\n  color: var(--color-text-muted);\n}\n\n.historyPagination {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.historyPageButton {\n  border: 1px solid var(--color-border);\n  border-radius: 999px;\n  background: var(--color-bg-muted);\n  color: var(--color-text);\n  font-size: var(--font-size-tiny);\n  padding: 4px 12px;\n  cursor: pointer;\n}\n\n.historyPageButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.historyPageButton:hover:not(:disabled) {\n  background: var(--color-bg-panel);\n  border-color: var(--color-accent);\n  color: var(--color-accent);\n}\n\n.historyPageButton:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--color-accent);\n}\n\n.historyPageInfo {\n  font-size: var(--font-size-tiny);\n  color: var(--color-text-muted);\n}\n\n.historyToggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: var(--font-size-tiny);\n  color: var(--color-text-muted);\n}\n\n.historyStatsButton {\n  margin-left: auto;\n  width: 34px;\n  height: 34px;\n  border-radius: 999px;\n  border: 1px solid var(--color-accent);\n  background-color: var(--color-accent);\n  color: var(--color-surface);\n  font-size: var(--font-size-body);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  gap: 6px;\n}\n\n.historyStatsButton:hover {\n  opacity: 0.9;\n}\n\n.historyStatsTooltip {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 6px 8px;\n  font-size: var(--font-size-tiny);\n  color: var(--color-text);\n  white-space: nowrap;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(-4px);\n  transition: opacity 0.2s ease, transform 0.2s ease;\n  z-index: 10;\n}\n\n.historyStatsButton:hover .historyStatsTooltip,\n.historyStatsButton:focus-visible .historyStatsTooltip {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.historyStatsOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.historyStatsBackdrop {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(2px);\n}\n\n.historyStatsModal {\n  position: relative;\n  z-index: 1;\n  width: min(30vw, 520px);\n  color: var(--color-text);\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);\n  font-weight: 700;\n}\n\n.historyStatsCard {\n  background-color: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  padding: 20px;\n}\n\n.historyStatsHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.historyStatsTitle {\n  font-size: var(--font-size-body);\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.historyStatsClose {\n  background: none;\n  border: none;\n  color: var(--color-text-muted);\n  font-size: var(--font-size-body);\n  cursor: pointer;\n}\n\n.historyStatsBody {\n  display: grid;\n  gap: 8px;\n  font-size: var(--font-size-body);\n  color: var(--color-text-muted);\n}\n\n.historyStatsViz {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 6px;\n}\n\n.historyStatsPieChart {\n  width: min(60%, 320px);\n  aspect-ratio: 1 / 1;\n  min-width: 140px;\n  height: auto;\n}\n\n.historyStatsLegend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  font-size: var(--font-size-body);\n  color: var(--color-text-muted);\n  width: 100%;\n  justify-content: center;\n}\n\n\n.historyStatsLegendItem {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.historyStatsLegendSwatch {\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n  display: inline-block;\n}\n\n.historyStatsLegendSuccess {\n  background-color: var(--color-success);\n}\n\n.historyStatsLegendFailed {\n  background-color: var(--color-danger);\n}\n\n.historyStatsLegendOther {\n  background-color: var(--color-warning);\n}\n\n.historyStatsRow {\n  display: flex;\n  justify-content: space-between;\n  font-size: var(--font-size-body);\n}\n\n.historyStatsFooter {\n  font-size: var(--font-size-body);\n  color: var(--color-text-muted);\n  margin-top: 6px;\n}\n\n.historyStatsEmpty {\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n}\n\n.historyEmpty {\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n}\n\n.setupInfoIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n  color: var(--color-text-muted);\n  font-size: var(--font-size-tiny);\n  cursor: default;\n  position: relative;\n}\n\n.setupTooltip {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 15;\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 10px 12px;\n  min-width: 240px;\n  max-width: 280px;\n  font-weight: 400;\n  font-size: var(--font-size-caption);\n  color: var(--color-text);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);\n  display: none;\n}\n\n.setupTooltipTitle {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 6px;\n  color: var(--color-text);\n}\n\n.setupTooltipList {\n  margin: 0;\n  padding-left: 16px;\n  color: var(--color-text-muted);\n}\n\n.setupInfoIcon:hover .setupTooltip,\n.setupInfoIcon:focus-visible .setupTooltip {\n  display: block;\n}\n\n.levels {\n  margin-top: 6px;\n  font-size: var(--font-size-label);\n  color: var(--color-text-muted);\n}\n\n.zoneToggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n  font-size: var(--font-size-caption);\n  color: var(--color-text);\n}\n\n.list {\n  margin: 6px 0 0 14px;\n  padding: 0;\n  color: var(--color-text-muted);\n  font-size: var(--font-size-caption);\n}\n\n.checklist {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.checkItem {\n  font-size: var(--font-size-tiny);\n  border-radius: 999px;\n  padding: 2px 6px;\n  border: 1px solid var(--color-border);\n}\n\n.checkPass {\n  color: var(--color-success);\n}\n\n.checkFail {\n  color: var(--color-danger);\n}\n\n@media (max-width: 1200px) {\n  .container {\n    grid-template-columns: 1fr;\n  }\n}\n\n.countdown {\n  font-size: var(--font-size-body);\n  font-weight: 600;\n  color: var(--color-text-strong);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TradeSetups_container__tLsgX`,
	"banner": `TradeSetups_banner__C0PhP`,
	"bannerText": `TradeSetups_bannerText__Kc6NU`,
	"bannerMenu": `TradeSetups_bannerMenu__W5Pfd`,
	"panel": `TradeSetups_panel__tvvyR`,
	"controls": `TradeSetups_controls__4Lyzq`,
	"controlsHeader": `TradeSetups_controlsHeader__5WvVx`,
	"macroBadge": `TradeSetups_macroBadge__89N+6`,
	"macroBadgeLabel": `TradeSetups_macroBadgeLabel__FYIXO`,
	"macroBadgeAsOf": `TradeSetups_macroBadgeAsOf__KT2KI`,
	"macroTooltip": `TradeSetups_macroTooltip__yIOtB`,
	"macroTooltipTitle": `TradeSetups_macroTooltipTitle__JHlNX`,
	"macroTooltipBody": `TradeSetups_macroTooltipBody__-9Zri`,
	"macroTooltipMeta": `TradeSetups_macroTooltipMeta__EeMur`,
	"kebabButton": `TradeSetups_kebabButton__SMqYc`,
	"kebabMenu": `TradeSetups_kebabMenu__++wvx`,
	"kebabBackdrop": `TradeSetups_kebabBackdrop__I784Z`,
	"menuOpen": `TradeSetups_menuOpen__OP8pU`,
	"confluenceTooltip": `TradeSetups_confluenceTooltip__saFSo`,
	"confidenceTooltip": `TradeSetups_confidenceTooltip__rJaAf`,
	"educationTooltip": `TradeSetups_educationTooltip__C-O-z`,
	"liquidityTooltip": `TradeSetups_liquidityTooltip__8OzqC`,
	"confluenceBadge": `TradeSetups_confluenceBadge__NbANj`,
	"confidenceBadge": `TradeSetups_confidenceBadge__tk0ly`,
	"educationIcon": `TradeSetups_educationIcon__2mR4C`,
	"liquidityBadge": `TradeSetups_liquidityBadge__W3z+q`,
	"menuDivider": `TradeSetups_menuDivider__iC4mu`,
	"menuSection": `TradeSetups_menuSection__RIYjK`,
	"menuLabelRow": `TradeSetups_menuLabelRow__itRKF`,
	"menuInfoIcon": `TradeSetups_menuInfoIcon__CBnwk`,
	"menuTooltip": `TradeSetups_menuTooltip__tF3oe`,
	"menuField": `TradeSetups_menuField__SbOCM`,
	"menuToggle": `TradeSetups_menuToggle__jFuee`,
	"menuLabel": `TradeSetups_menuLabel__50oaz`,
	"menuValue": `TradeSetups_menuValue__Rkwgo`,
	"liquiditySettingsBox": `TradeSetups_liquiditySettingsBox__e31UF`,
	"liquiditySettingsTitle": `TradeSetups_liquiditySettingsTitle__2MKdF`,
	"slider": `TradeSetups_slider__LOlwC`,
	"controlGroup": `TradeSetups_controlGroup__NFwn1`,
	"controlLabel": `TradeSetups_controlLabel__FAPPU`,
	"select": `TradeSetups_select__i-tIF`,
	"input": `TradeSetups_input__CsH0g`,
	"symbolAddRow": `TradeSetups_symbolAddRow__g2qfM`,
	"addButton": `TradeSetups_addButton__ihSe2`,
	"symbolError": `TradeSetups_symbolError__gb0B9`,
	"symbolList": `TradeSetups_symbolList__03Em0`,
	"symbolChip": `TradeSetups_symbolChip__BRPhV`,
	"symbolRemove": `TradeSetups_symbolRemove__hOu63`,
	"toggleRow": `TradeSetups_toggleRow__x0PLM`,
	"filtersSection": `TradeSetups_filtersSection__-PRZZ`,
	"filtersTitle": `TradeSetups_filtersTitle__lKLcJ`,
	"filtersGrid": `TradeSetups_filtersGrid__6+GiA`,
	"filterToggle": `TradeSetups_filterToggle__MNZ7A`,
	"filtersNote": `TradeSetups_filtersNote__C8sfB`,
	"chartPanel": `TradeSetups_chartPanel__s-+ks`,
	"setupsHeader": `TradeSetups_setupsHeader__ynXBz`,
	"setupsHeaderLeft": `TradeSetups_setupsHeaderLeft__CwaQw`,
	"setupsHeaderRight": `TradeSetups_setupsHeaderRight__RPS6f`,
	"setupsHeaderTitle": `TradeSetups_setupsHeaderTitle__g-xB+`,
	"setupsHeaderMeta": `TradeSetups_setupsHeaderMeta__xRjW4`,
	"setupsTabs": `TradeSetups_setupsTabs__ukJfv`,
	"setupsTab": `TradeSetups_setupsTab__T2ytl`,
	"setupsTabActive": `TradeSetups_setupsTabActive__pa16e`,
	"educationTooltipTitle": `TradeSetups_educationTooltipTitle__EwGt4`,
	"educationTooltipList": `TradeSetups_educationTooltipList__ElqIv`,
	"setupCard": `TradeSetups_setupCard__YIAKR`,
	"setupCardExpired": `TradeSetups_setupCardExpired__n2TYh`,
	"setupTitleRow": `TradeSetups_setupTitleRow__b2kjv`,
	"setupBadgeRow": `TradeSetups_setupBadgeRow__veYrH`,
	"liquidityList": `TradeSetups_liquidityList__a3XBU`,
	"liquidityCard": `TradeSetups_liquidityCard__bQO98`,
	"liquidityHeader": `TradeSetups_liquidityHeader__vH5mw`,
	"liquidityTitle": `TradeSetups_liquidityTitle__E-Ft5`,
	"liquidityRange": `TradeSetups_liquidityRange__t2ocv`,
	"liquidityMeta": `TradeSetups_liquidityMeta__OYtSc`,
	"liquidityActions": `TradeSetups_liquidityActions__eyPG8`,
	"liquidityToggle": `TradeSetups_liquidityToggle__2i9Es`,
	"liquidityZoomButton": `TradeSetups_liquidityZoomButton__yRP4Q`,
	"setupActions": `TradeSetups_setupActions__fayK6`,
	"fitSetupButton": `TradeSetups_fitSetupButton__QLnjJ`,
	"zoomSetupButton": `TradeSetups_zoomSetupButton__HmMk1`,
	"liquidityEmpty": `TradeSetups_liquidityEmpty__6NlMs`,
	"badge": `TradeSetups_badge__N3OZ6`,
	"badgeActive": `TradeSetups_badgeActive__OWX2m`,
	"badgeTriggered": `TradeSetups_badgeTriggered__c03mS`,
	"badgeExpired": `TradeSetups_badgeExpired__uUU2O`,
	"badgeHigh": `TradeSetups_badgeHigh__xMfsA`,
	"badgeMed": `TradeSetups_badgeMed__pvXDQ`,
	"badgeLow": `TradeSetups_badgeLow__km6st`,
	"badgeFvg": `TradeSetups_badgeFvg__49xL4`,
	"liquidityaligned": `TradeSetups_liquidityaligned__1OoYf`,
	"liquiditycounter": `TradeSetups_liquiditycounter__tbXHV`,
	"liquiditynone": `TradeSetups_liquiditynone__W6ueU`,
	"confidenceTooltipTitle": `TradeSetups_confidenceTooltipTitle__EkYyU`,
	"confidenceTooltipList": `TradeSetups_confidenceTooltipList__0AHy5`,
	"confluenceAligned": `TradeSetups_confluenceAligned__czMyC`,
	"confluenceCounter": `TradeSetups_confluenceCounter__Pt+Yc`,
	"confluenceNeutral": `TradeSetups_confluenceNeutral__xnbOG`,
	"confluenceUnavailable": `TradeSetups_confluenceUnavailable__DHBZJ`,
	"sessionBadge": `TradeSetups_sessionBadge__kt78y`,
	"expiredNote": `TradeSetups_expiredNote__fqTsN`,
	"macroFootnote": `TradeSetups_macroFootnote__KlcpK`,
	"historySection": `TradeSetups_historySection__2BlbW`,
	"historyHeader": `TradeSetups_historyHeader__dA8N2`,
	"historyChevron": `TradeSetups_historyChevron__DANaJ`,
	"historyList": `TradeSetups_historyList__rlYhf`,
	"historyCard": `TradeSetups_historyCard__IB+29`,
	"historyCardHeader": `TradeSetups_historyCardHeader__1BCAO`,
	"historyExpandButton": `TradeSetups_historyExpandButton__6IQ3P`,
	"historyCardTitle": `TradeSetups_historyCardTitle__w7Y85`,
	"historyStatusBadge": `TradeSetups_historyStatusBadge__zGdkb`,
	"historyStatusSuccess": `TradeSetups_historyStatusSuccess__52E8T`,
	"historyStatusFailed": `TradeSetups_historyStatusFailed__o4x8J`,
	"historyStatusTriggered": `TradeSetups_historyStatusTriggered__qQgBY`,
	"historyTimestamp": `TradeSetups_historyTimestamp__g50zc`,
	"historyGrid": `TradeSetups_historyGrid__jWndx`,
	"historyGridItem": `TradeSetups_historyGridItem__BZiVT`,
	"historyGridLabel": `TradeSetups_historyGridLabel__URnhK`,
	"historyGridValue": `TradeSetups_historyGridValue__s9vLj`,
	"historyFooter": `TradeSetups_historyFooter__cuUkj`,
	"historyFooterNote": `TradeSetups_historyFooterNote__Z-0n8`,
	"historyPagination": `TradeSetups_historyPagination__0r7jn`,
	"historyPageButton": `TradeSetups_historyPageButton__rN3IY`,
	"historyPageInfo": `TradeSetups_historyPageInfo__ywIeK`,
	"historyToggle": `TradeSetups_historyToggle__sRBBL`,
	"historyStatsButton": `TradeSetups_historyStatsButton__4dx4W`,
	"historyStatsTooltip": `TradeSetups_historyStatsTooltip__AngII`,
	"historyStatsOverlay": `TradeSetups_historyStatsOverlay__93DGz`,
	"historyStatsBackdrop": `TradeSetups_historyStatsBackdrop__DQaAf`,
	"historyStatsModal": `TradeSetups_historyStatsModal__kzwJK`,
	"historyStatsCard": `TradeSetups_historyStatsCard__lq1gA`,
	"historyStatsHeader": `TradeSetups_historyStatsHeader__kX9ou`,
	"historyStatsTitle": `TradeSetups_historyStatsTitle__6g-bB`,
	"historyStatsClose": `TradeSetups_historyStatsClose__1cj0B`,
	"historyStatsBody": `TradeSetups_historyStatsBody__dPIBH`,
	"historyStatsViz": `TradeSetups_historyStatsViz__2Zwnv`,
	"historyStatsPieChart": `TradeSetups_historyStatsPieChart__+5cin`,
	"historyStatsLegend": `TradeSetups_historyStatsLegend__f1FrT`,
	"historyStatsLegendItem": `TradeSetups_historyStatsLegendItem__oAuiH`,
	"historyStatsLegendSwatch": `TradeSetups_historyStatsLegendSwatch__c4wWd`,
	"historyStatsLegendSuccess": `TradeSetups_historyStatsLegendSuccess__N0QwY`,
	"historyStatsLegendFailed": `TradeSetups_historyStatsLegendFailed__1BSQI`,
	"historyStatsLegendOther": `TradeSetups_historyStatsLegendOther__hyzBD`,
	"historyStatsRow": `TradeSetups_historyStatsRow__8FzNE`,
	"historyStatsFooter": `TradeSetups_historyStatsFooter__+bVJ9`,
	"historyStatsEmpty": `TradeSetups_historyStatsEmpty__rf-S1`,
	"historyEmpty": `TradeSetups_historyEmpty__ylwtw`,
	"setupInfoIcon": `TradeSetups_setupInfoIcon__v9HqQ`,
	"setupTooltip": `TradeSetups_setupTooltip__ruM1z`,
	"setupTooltipTitle": `TradeSetups_setupTooltipTitle__A4jwK`,
	"setupTooltipList": `TradeSetups_setupTooltipList__AB0zd`,
	"levels": `TradeSetups_levels__tHIea`,
	"zoneToggle": `TradeSetups_zoneToggle__bPuRX`,
	"list": `TradeSetups_list__WooyY`,
	"checklist": `TradeSetups_checklist__txln+`,
	"checkItem": `TradeSetups_checkItem__pAtUh`,
	"checkPass": `TradeSetups_checkPass__Bc9Mr`,
	"checkFail": `TradeSetups_checkFail__jyEk3`,
	"countdown": `TradeSetups_countdown__5MjB6`
};
export default ___CSS_LOADER_EXPORT___;
